import Enum from "../../../../class/Enum";

const ReceptionMean = Enum.make({
	collect: "COLLECT",
	delivery: "DELIVERY",
});

export default ReceptionMean;
